import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/27/thumb-landscape.jpg"

const Post27 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">kate spade／2WAYバッグ／27 x22 x14cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>有名な海外セレブや芸能人、モデルらが愛用するブランド「ケイト・スペード（kate spade）」には、数多くのバッグがあります。そのなかでも「ブランドバッグ使い放題のラクサス」で人気のバッグをご紹介します。あなたの使いたいバッグはどれですか？</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>2WAYバッグ／LIGHT GRAY（ライトグレー）／PXRU4471CT</h2>
          <p>こなれた印象のサイズ感でとてもキュートなバッグ。華やかな印象を与えるデザインのフォルムや色使いはちょっとしたお出かけやパーティなどでも大活躍すること間違いなしです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/27/1.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/2.jpg" alt="" />
              <span className="text-center">29x23x12cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>2WAYバッグ／BIG SMOKE／PXRU4943</h2>
          <p>シボ感のある良質なレザーを使用したケイトスペードの2wayショルダーバッグ。丸みのある台形フォルムが可愛いバッグはストラップチェンジできてコーデの幅も広がります♪深めの底マチにはリボンがデザインされ、見えにくい場所まで可愛さを演出♪</p>          
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/27/3.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/4.jpg" alt="" />
              <span className="text-center">29x22x14cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>2WAYバッグ／BLACK/CHAMPAGNE／PXRU4471</h2>
          <p>デイリーユースにぴったりのcedar streetシリーズ。カジュアルからキレイ系まで幅広いコーディネートにあわせやすいシンプルなデザインが魅力です。ゴールドのロゴやチェーン使いが華やかな雰囲気です♪</p>
        </div>
        <div className="img-two-cloumn">
        <figure className="img-small">
              <StaticImage src="../../images/posts/27/5.jpg" alt="" />
            </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/6.jpg" alt="" />
              <span className="text-center">28x22x12cm</span>
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>ショルダーバッグ／BLACK/CREAM（ブラック/クリーム）／PXRU5526</h2>
          <p>レザー×ファブリックの異素材コントラストが新鮮。スリムなシルエットに内ポケット付きで荷物の出し入れもスムーズにできます。定番のボーダーパターンでカジュアルスタイルにもマッチするデザインです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/27/7.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/8.jpg" alt="" />
              <span className="text-center">32x21x5cm</span>
          </figure>
        </div>    
        <div className="text-max-width">
          <h2>スモールリアン／SMALL RYAN／RED（レッド）／PXRU5754</h2>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/10.jpg" alt="" />
              <span className="text-center">26x24x12cm</span>
          </figure>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/katespade" className="view-all-button">
          ケイト・スペードのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>2WAYバッグ／BLACK（黒）／PXRU5267</h2>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/11.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/12.jpg" alt="" />
              <span className="text-center">37x27x17cm</span>
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>2WAYバッグ／PINK（ピンク）</h2>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/13.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/14.jpg" alt="" />
              <span className="text-center">32x24x14cm</span>
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>2WAYバッグ／GRAY（グレー）／PXRU5267</h2>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/27/15.jpg" alt="" />
          </figure>            
          <figure className="img-small">
            <StaticImage src="../../images/posts/27/16.jpg" alt="" />
            <span className="text-center">37x27x17cm</span>
          </figure>
        </div>      
        <div className="text-max-width">
          <h2>2WAYバッグ／PINK（ピンク）／PXRU4471</h2>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/27/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/27/18.jpg" alt="" />
            <span className="text-center">29x22x10cm</span>
          </figure>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/katespade" className="view-all-button">
          ケイト・スペードのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post27

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 27}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
